import { render, staticRenderFns } from "./RedButton.vue?vue&type=template&id=0dbd514c&scoped=true&"
import script from "./RedButton.vue?vue&type=script&lang=js&"
export * from "./RedButton.vue?vue&type=script&lang=js&"
import style0 from "./RedButton.vue?vue&type=style&index=0&id=0dbd514c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd514c",
  null
  
)

export default component.exports